import apiRequest from './apiRequest';

type Response = Record<string, never>; // Returns an empty object on success

export default async function deleteProject(projectID: string) {
  return await apiRequest<Response>(
    'mogen-orchestration',
    `/v2/projects/${projectID}`,
    {
      method: 'DELETE',
    },
  );
}
